import ServerServices from "@/services/uteis/ServerServices.js";
import { Libs } from "@/libs/libs.js";
class ApiServices {
  constructor() {
    this.ServerServices = ServerServices;
    this.Libs = Libs;
  }

  async get(url, params = {}) {
    try {
      const response = await this.ServerServices.get(`${url}${this.Libs.jsonToQueryString(params)}`);
      return response;
    } catch (error) {
      console.error("Error fetching data:", error);
      throw error;
    }
  }

  async post(url, data = {}) {
    try {
      let config = {};
      // Não setar Content-Type manualmente para FormData!
      // O axios faz isso automaticamente, incluindo o boundary correto
      const response = await this.ServerServices.post(url, data, config);
      return response;
    } catch (error) {
      console.error("Error posting data:", error);
      throw error;
    }
  }

  async getBlob(url) {
    try {
      const response = await this.ServerServices.get(url, { responseType: "blob" });
      return response;
    } catch (error) {
      console.error("Error fetching file:", error);
      throw error;
    }
  }

  async put(url, data = {}) {
    try {
      const response = await this.ServerServices.put(url, data);
      return response;
    } catch (error) {
      console.error("Error updating data:", error);
      throw error;
    }
  }

  async delete(url, data = {}) {
    try {
      const response = await this.ServerServices.delete(url, { data });
      return response;
    } catch (error) {
      console.error("Error deleting data:", error);
      throw error;
    }
  }
}

export default new ApiServices();
